import React from "react";
import { reactIcons } from "../utils/icons";

export const FormButton = ({
  type,
  func,
  title,
  customcls,
  isLoading,
  spinner,
  disabled,
}) => {
  return (
    <button
      // a button with its own click action does only that: without a type it also submitted the form around it (the
      // purchase receive form's Edit opened "Save these changes?"; Save buttons calling handleSubmit sent twice)
      type={type || (func ? "button" : undefined)}
      onClick={func}
      disabled={isLoading || disabled} // disabled: a button that cannot be used yet (e.g. Split View's Edit without sub-items)
      // SGEW 17 Oct: the shared button look (index.css .sgew-btn - rounded, Poppins 14px semibold, 38px); customcls names
      // its colour (sgew-btn-cancel, sgew-btn-success, sgew-btn-danger, sgew-btn-neutral, sgew-btn-outline), primary otherwise
      className={`sgew-btn ${customcls ? customcls : "sgew-btn-primary"}`}
    >
      {title}
      {isLoading && (
        <span className="animate-spin inline-flex">
          {reactIcons.spinLoader}
        </span>
      )}
    </button>
  );
};

export default FormButton;
